import request from "@utils/request";

export function getTickSpread(query) {
    return request({
        url: "data/tick-spread",
        method: "GET",
        params: query
    });
}